export const CURRENCIES = ["MXN", "USD", "EUR"];
export const NO_CURRENCY = "SIN_MONEDA";
export const EMPTY = "Sin definir";

const nf = new Intl.NumberFormat("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const money = (v, cur) => (v == null ? EMPTY : `$${nf.format(v)}${cur ? ` ${cur}` : ""}`);
export const curLabel = (c) => (c === NO_CURRENCY || !c ? "Sin moneda" : c);
export const fmtDate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};
export const fmtDateTime = (iso) => new Date(iso).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" });

export const INVESTMENT_TYPES = { participacion: "Participación", prestamo: "Préstamo", inmueble: "Inmueble", proyecto: "Proyecto", otro: "Otro" };
export const INVESTMENT_STATUS = { activa: "Activa", en_salida: "En salida", cerrada: "Cerrada" };
export const LOAN_STATUS = { vigente: "Vigente", vencido: "Vencido", liquidado: "Liquidado", sin_definir: "Sin definir" };
export const INVESTMENT_MOVES = { aportacion: "Aportación", retorno: "Retorno", retiro: "Retiro", valuacion: "Valuación" };
export const LOAN_MOVES = { desembolso: "Desembolso adicional", pago_capital: "Pago de capital", pago_interes: "Pago de interés" };
const CUR_OPTS = { MXN: "MXN", USD: "USD", EUR: "EUR" };

export const INVESTMENT_FIELDS = [
  { key: "name", label: "Negocio", type: "text", required: true },
  { key: "associated_contact_name", label: "Socio / empresa (texto)", type: "text" },
  { key: "contact_id", label: "Contacto ligado (Red)", type: "contact" },
  { key: "type", label: "Tipo", type: "select", options: INVESTMENT_TYPES },
  { key: "status", label: "Estatus", type: "select", options: INVESTMENT_STATUS },
  { key: "currency", label: "Moneda", type: "select", options: CUR_OPTS },
  { key: "committed_amount", label: "Monto comprometido", type: "money" },
  { key: "participation_pct", label: "% de participación", type: "pct" },
  { key: "agreed_yield_pct", label: "% rendimiento pactado", type: "pct" },
  { key: "yield_period", label: "Periodicidad del rendimiento", type: "text" },
  { key: "start_date", label: "Fecha de inicio", type: "date" },
  { key: "term_date", label: "Vencimiento", type: "date" },
  { key: "review_date", label: "Revisión", type: "date" },
  { key: "exit_date", label: "Salida", type: "date" },
  { key: "term_note", label: "Plazo / notas de plazo", type: "text" },
  { key: "notes", label: "Notas", type: "textarea" },
];

export const LOAN_FIELDS = [
  { key: "borrower_name", label: "Quién recibió el préstamo", type: "text", required: true },
  { key: "contact_id", label: "Contacto ligado (Red)", type: "contact" },
  { key: "status", label: "Estatus", type: "select", options: LOAN_STATUS },
  { key: "currency", label: "Moneda", type: "select", options: CUR_OPTS },
  { key: "principal", label: "Capital prestado", type: "money" },
  { key: "interest_rate_pct", label: "% de interés", type: "pct" },
  { key: "interest_periodicity", label: "Periodicidad del interés", type: "text" },
  { key: "start_date", label: "Fecha de inicio", type: "date" },
  { key: "due_date", label: "Vencimiento", type: "date" },
  { key: "notes", label: "Notas", type: "textarea" },
];

export const displayValue = (field, item, cats = {}) => {
  const v = item[field.key];
  if (field.type === "bool") return v ? "Sí" : "No";
  if (v == null || v === "" || (Array.isArray(v) && !v.length)) return null;
  if (field.type === "select") {
    const opts = field.options || Object.fromEntries((cats[field.catalog] || []).map((i) => [i.key, i.label]));
    return opts[v] || v;
  }
  if (field.type === "contact" || field.type === "user") return item.names?.[v] || "Sin acceso";
  if (field.type === "contacts") return v.map((id) => item.names?.[id]).filter(Boolean).join(", ") || null;
  if (field.type === "tags") return v.join(", ");
  if (field.type === "money") return money(v, field.currencyKey ? item[field.currencyKey] : item.currency);
  if (field.type === "pct") return `${v}%`;
  if (field.type === "date") return fmtDate(v);
  return String(v);
};
